import { VariantProps, cva } from 'class-variance-authority'
import { FC } from 'react'
import { ChannelType } from '~/stores/stores.types'

import { Icon, IconTypes } from '@hap/components'

export const getIcon = (
  type?: string,
): { name: IconTypes; title: string; className: string; weight?: 'fill' } => {
  switch (type) {
    case 'chat':
      return {
        name: 'chat-circle',
        title: 'Chat',
        className: 'shrink-0 fill-[#57c976]',
        weight: 'fill',
      }
    case 'phone':
      return {
        name: 'phone',
        title: 'Inbound call',
        className: 'shrink-0 fill-[#00b1c9]',
        weight: 'fill',
      }
    case 'outbound-phone':
      return {
        name: 'phone-outgoing',
        title: 'Outbound call',
        className: 'shrink-0 fill-[#00b1c9]',
        weight: 'fill',
      }
    case 'email':
      return {
        name: 'paper-plane-tilt',
        title: 'Email',
        className: 'shrink-0 fill-[#e63298]',
        weight: 'fill',
      }
    case 'sms':
      return {
        name: 'chats-circle',
        title: 'SMS',
        className: 'shrink-0 fill-[#00b1c9]',
        weight: 'fill',
      }

    default:
      return { name: 'file', title: 'unknown', className: 'fill-[#e63298]' }
  }
}

const badgeVariants = cva(
  'text-primary flex aspect-square w-9 items-center justify-center rounded-md text-center',
  {
    variants: {
      variant: {
        ghost: 'bg-transparent',
        default: 'bg-accent',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

const ChannelBadge: FC<ChannelBadgeProps> = ({ type, className, variant }) => (
  <div className={badgeVariants({ variant, className })}>
    <Icon {...getIcon(type)} stroke="0" />
  </div>
)

interface ChannelBadgeProps extends VariantProps<typeof badgeVariants> {
  type?: ChannelType
  className?: string
}

export default ChannelBadge
